// @intent: Apply RFC 6902 patches to a Project — string-path adapter on top of immer.applyPatches
// @flow: consumed by useProject store (external patch ingest) and by tests
// @stale: when immer changes its Patch type shape; when move/copy ops are supported (W5)

import { applyPatches, enablePatches, type Patch as ImmerPatch } from 'immer';
import type { Project, Patch } from './types';
import { pathToArray } from './pathAdapter';

enablePatches();

export function applyPatch(project: Project, patch: Patch): Project {
  const immerPatches: ImmerPatch[] = patch.map((op) => {
    const path = pathToArray(op.path) as ImmerPatch['path'];
    switch (op.op) {
      case 'replace':
      case 'add':
      case 'remove':
        return { op: op.op, path, value: op.value };
      case 'move':
      case 'copy':
        throw new Error(`${op.op} op not yet supported in W4 (will land in W5)`);
      default: {
        const _exhaustive: never = op.op;
        throw new Error(`Unknown JSON Patch op: ${String(_exhaustive)}`);
      }
    }
  });
  return applyPatches(project, immerPatches);
}
